import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-gdo-product',
    templateUrl: './gdo-product.component.html',
    styleUrls: ['./gdo-product.component.scss'],
    standalone: false
})
export class GdoProductComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
